import React from 'react';
import '../assets/css/About.css';

function About() {
  return (
    <section id="about" className="about-section">
      <div className="about-container">
        
        <div className="about-content">
          <h1 className="about-title">من نحن</h1>
          <h3 className="about-subtitle">
            نُحدث فرقًا رقميًا من قلب فلسطين
          </h3>
          <p className="about-text">
            نحن في <span className="company-name-en">Peony Technologies</span> نؤمن أن التكنولوجيا هي المُحرّك الحقيقي للتغيير. نُقدم حلولاً برمجية متكاملة تشمل تطوير المواقع الإلكترونية، تطبيقات الهواتف الذكية، والأنظمة الذكية المصممة خصيصًا لتلبية احتياجات السوق المحلي والإقليمي.
          </p>
          <p className="about-text">
            نعمل بشغف واحترافية، ونمزج بين الابتكار والتقنية لنساعدك على بناء مستقبل رقمي قوي ومميز.
          </p>
        </div>

      </div>
    </section>
  );
}

export default About;